import { gql, graphql } from 'react-apollo';

import StackList from '../components/StackList';

const STACK_LIST_QUERY = gql`
  query stacks($last: Int!, $skip: Int!) {
    allStacks(last: $last, skip: $skip, orderBy: updatedAt_DESC) {
      id
      name
      slug
      description
      url
      image {
        id
        name
        url
      }
      tools {
        id
        name
        slug
        image {
          id
          name
          url
        }
      }
    }
    _allStacksMeta(filter: {}) {
      count
    }
  }
`;

export default graphql(STACK_LIST_QUERY, {
  options: () => {
    return {
      fetchPolicy: 'cache-and-network',
      variables: {
        last: 20,
        skip: 0,
      },
    };
  },
  props: ({ ownProps, data }) => {
    return {
      data,
      hasMore:
        data._allStacksMeta &&
        data.allStacks &&
        data._allStacksMeta.count > data.allStacks.length,
      onLoadMore: () => {
        return data.fetchMore({
          variables: {
            skip: data.allStacks.length,
          },
          updateQuery: (previousResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) {
              return previousResult;
            }

            const newResult = {
              allStacks: [
                ...previousResult.allStacks,
                ...fetchMoreResult.allStacks,
              ],
            };

            return newResult;
          },
        });
      },
    };
  },
})(StackList);



// WEBPACK FOOTER //
// ./src/App/Stack/containers/StackList.js